import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "10", height: "7", x: "12", y: "13", rx: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PictureInPicture2";
const PictureInPicture2 = memo(themed(Icon));
export {
  PictureInPicture2
};
//# sourceMappingURL=picture-in-picture-2.js.map
